var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockInIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.6,163.9c-38.1-0.1-66.4-28.6-66.3-66.9c0.1-36.6,30.1-66.4,66.8-66.3c36.8,0.1,66.3,30.1,66.4,67.1 C157.3,127.6,135.7,164.7,90.6,163.9z M90.7,151.4c29.9,0,54.2-24.1,54.2-53.9c0-29.6-24.4-54.1-54-54.2 c-29.5-0.1-54.1,24.5-54.2,54.1C36.6,127.1,60.8,151.4,90.7,151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,22.5c11.2-8.2,29.1-6.1,39.7,4.3c11,10.7,13.3,28.4,5,40.5C156.7,46.5,142.1,31.6,121,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7,67.4c-8.2-12.6-6.1-29.2,4.4-40c10.5-10.8,27.3-13.2,40.5-5.1C39.8,31.5,24.8,46.2,15.7,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,70.8c3.5,3.7,6.2,6.3,8.5,8.8c-14.4,14.1-28.8,28.3-43.6,42.9c-6.9-6.6-15-14.3-23.4-22.3c3.2-2.8,6.1-5.4,9.5-8.3 c4.6,4.3,9.6,8.9,14.5,13.4C93.1,93.9,104.5,82.5,116,70.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockInIcon);
export default __webpack_public_path__ + "static/media/ClockInIcon.3945d0c5.svg";
export { ForwardRef as ReactComponent };